<script>
export default {
  name: 'ItineraryPricesPriceSelectorMinorPax',
  props: {
    childAges: {
      type: Array,
      default: () => [],
    },
    discounts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      toggled: false,
      localChildAges: [],
    };
  },
  created() {
    if (this.childAges.length) {
      this.localChildAges = [...this.childAges];
    } else {
      this.addRow();
    }
  },
  methods: {
    validateAge(value) {
      if (this.discounts.some(discount => value >= +discount.ageFrom && value <= +discount.ageTo)) {
        return true;
      }
      return 'NOT VALID';
    },
    setAge(index, value) {
      const childAges = [...this.localChildAges];
      childAges[index] = +value;
      this.localChildAges = childAges;
    },
    addRow() {
      const childAges = [...this.localChildAges];
      childAges.push(10);
      this.localChildAges = childAges;
    },
    deleteRow(index) {
      const childAges = [...this.localChildAges];
      childAges.splice(index, 1);
      this.localChildAges = childAges;
    },
    update() {
      this.toggled = false;
      const filteredChildAges = this.localChildAges.filter(age => age !== null);
      this.$emit('update', filteredChildAges);
    },
  },
};
</script>

<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="toggled"
      width="400"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="deep-orange"
          v-on="on"
        >
          <v-icon>child_care</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          <v-layout>
            <v-flex xs10 mt-2>
              Children paxes
            </v-flex>
            <v-flex justify-end>
              <v-btn
                color="primary"
                icon
                @click="addRow"
              >
                <v-icon>add</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-card-text>
          <v-layout
            v-for="(age, index) in localChildAges"
            :key="index"
            row
            mb-2
          >
            <v-flex xs10 mr-1>
              <v-text-field
                :value="age"
                :rules="[validateAge]"
                label="Age"
                box
                hide-details
                @input="setAge(index, $event)"
              />
            </v-flex>
            <v-flex>
              <v-btn
                color="red"
                flat
                icon
                @click="deleteRow(index)"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error"
            @click="toggled = false"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            @click="update"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/itinerary/itineraryPrices/ItineraryPricesPriceSelectorMinorPax.vue